(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["become-wholesaler"] && !Shopify.designMode) return;
  try {
    
(() => {
  const attachedRoots = new WeakSet();
  const watchedSections = new WeakSet();
  const sourceId = 'custom#how_did_you_hear_about_us-selector-value';
  const representativeId = 'custom#sales_representative_name';
  const selectId = 'moshita-sales-representative-choice';
  const choices = ['Kaitlyn Perrone', 'Michael Johnson'];
  const attach = (host) => {
    const root = host.shadowRoot;
    if (!root || attachedRoots.has(root)) return;
    attachedRoots.add(root);
    let syncing = false;
    const isRepresentative = () => root.getElementById(sourceId)?.textContent.trim() === 'Sales representative';
    const writeValue = (input, value) => {
      if (input.value === value) return;
      Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(input, value);
      input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
      input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    };
    const sync = () => {
      if (syncing) return;
      const source = root.getElementById(sourceId);
      const input = root.getElementById(representativeId);
      if (!source || !input) return;
      syncing = true;
      try {
        const field = input.parentElement;
        let select = root.getElementById(selectId);
        if (!select) {
          const wrapper = document.createElement('div');
          wrapper.dataset.moshitaRepDropdown = '';
          wrapper.style.cssText = 'width:100%;min-width:0;grid-column:1 / -1;';
          const label = document.createElement('label');
          label.htmlFor = selectId;
          label.textContent = input.labels?.[0]?.textContent || 'Sales representative name';
          label.style.cssText = 'display:block;font:inherit;font-size:14px;margin:0 0 8px;';
          select = document.createElement('select');
          select.id = selectId;
          select.setAttribute('aria-label', label.textContent);
          const style = getComputedStyle(input);
          select.style.cssText = 'display:block;width:100%;box-sizing:border-box;min-height:50px;padding:12px 38px 12px 14px;cursor:pointer;';
          ['fontFamily', 'fontSize', 'color', 'backgroundColor', 'border', 'borderRadius'].forEach((key) => { select.style[key] = style[key]; });
          select.append(new Option('Select your sales representative', ''));
          choices.forEach((name) => select.append(new Option(name, name)));
          select.addEventListener('change', () => {
            const current = root.getElementById(representativeId);
            if (current) writeValue(current, choices.includes(select.value) ? select.value : '');
          });
          wrapper.append(label, select);
          field.after(wrapper);
        }
        const show = isRepresentative();
        field.hidden = true;
        field.style.display = 'none';
        input.required = false;
        input.setAttribute('aria-required', 'false');
        select.parentElement.hidden = !show;
        select.parentElement.style.display = show ? '' : 'none';
        select.disabled = !show;
        select.required = show;
        select.setAttribute('aria-required', String(show));
        if (!show || !choices.includes(input.value)) writeValue(input, '');
        select.value = input.value;
      } finally {
        syncing = false;
      }
    };
    root.addEventListener('submit', (event) => {
      sync();
      const select = root.getElementById(selectId);
      if (isRepresentative() && select && !select.checkValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        select.reportValidity();
        select.focus();
      }
    }, true);
    root.addEventListener('input', (event) => { if (event.target.id !== selectId) sync(); });
    root.addEventListener('change', sync);
    new MutationObserver(sync).observe(root, { childList: true, subtree: true, characterData: true });
    sync();
  };
  const scan = () => document.querySelectorAll('[data-forms-id="forms-root-1154406"] shopify-forms-embed').forEach(attach);
  const start = () => {
    document.querySelectorAll('.wholesale-page').forEach((section) => {
      if (watchedSections.has(section)) return;
      watchedSections.add(section);
      new MutationObserver(scan).observe(section, { childList: true, subtree: true });
    });
    scan();
    customElements.whenDefined('shopify-forms-embed').then(scan);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moshita-retail-shipping"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('moshita-shipping-banner')) {
    customElements.define('moshita-shipping-banner', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        clearTimeout(this.timer);
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = [...this.querySelectorAll('[data-announcement]')];
        if (this.slides.length < 2) return;
        this.index = 0;
        this.hovered = false;
        this.focused = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.showSlide();
        this.addEventListener('pointerdown', event => { this.startX = event.clientX; this.startY = event.clientY; }, options);
        this.addEventListener('pointerup', event => {
          const distance = event.clientX - this.startX;
          if (Math.abs(distance) > 40 && Math.abs(distance) > Math.abs(event.clientY - this.startY)) {
            this.index = (this.index + 1) % this.slides.length;
            this.showSlide(true);
            this.schedule();
          }
        }, options);
        this.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.schedule();
        }, options);
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.schedule();
        }, options);
        this.addEventListener('focusin', () => {
          this.focused = true;
          this.schedule();
        }, options);
        this.addEventListener('focusout', event => {
          this.focused = this.contains(event.relatedTarget);
          this.schedule();
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', event => {
          this.paused = event.matches;
          this.schedule();
        }, options);
        this.schedule();
      }
      showSlide(animate = false) {
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.getAnimations().forEach(animation => animation.cancel());
          slide.setAttribute('aria-hidden', String(!active));
          if (animate && !this.motion.matches) {
            slide.animate(active ? [{ transform: 'translateX(36px)', opacity: 0 }, { transform: 'translateX(0)', opacity: 1 }] : [{ transform: 'translateX(0)', opacity: 1 }, { transform: 'translateX(-36px)', opacity: 0 }], { duration: 450, easing: 'ease-out' });
          }
          if (slide.matches('a, button')) slide.tabIndex = active ? 0 : -1;
        });
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || this.paused || this.hovered || this.focused || document.hidden) return;
        this.timer = setTimeout(() => {
          this.index = (this.index + 1) % this.slides.length;
          this.showSlide(true);
          this.schedule();
        }, Math.max(3, Number(this.dataset.interval) || 6) * 1000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moshita-welcome-popup"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('moshita-welcome-popup'))customElements.define('moshita-welcome-popup',class extends HTMLElement{
    connectedCallback(){
      this.dialog=this.querySelector('dialog');if(!this.dialog?.showModal)return;
      this.editor=this.dataset.editor==='true';this.storageKey='moshita.signup.dismissed.v1';this.pendingKey='moshita.signup.pending';this.bubbleKey='moshita.signup.bubble.dismissed.v1';this.bubble=this.querySelector('[data-welcome-bubble]');this.abortController=new AbortController();const options={signal:this.abortController.signal};
      this.querySelector('[data-welcome-hide]')?.addEventListener('click',()=>{clearTimeout(this.timer);this.bubble.hidden=true;this.remember();if(!this.editor)try{localStorage.setItem(this.bubbleKey,String(Date.now()+Number(this.dataset.days)*86400000))}catch(err){}},options);
      const dismiss=()=>{this.remember();this.dialog.close()};
      this.querySelectorAll('[data-welcome-close]').forEach(b=>b.addEventListener('click',dismiss,options));
      this.dialog.addEventListener('cancel',()=>this.remember(),options);this.dialog.addEventListener('close',()=>{this.unlockScroll();this.removeAttribute('data-open');document.querySelectorAll('[data-welcome-open]').forEach(b=>b.setAttribute('aria-expanded','false'));this.opener?.focus({preventScroll:true})},options);
      this.dialog.addEventListener('click',e=>{if(e.target!==this.dialog)return;const b=this.dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)dismiss()},options);
      const enableOpeners=()=>{let bubbleUntil=0;try{bubbleUntil=Number(localStorage.getItem(this.bubbleKey))||0}catch(err){}this.bubble.hidden=!this.editor&&bubbleUntil>Date.now();document.querySelectorAll('[data-welcome-footer]').forEach(el=>el.hidden=false);document.querySelectorAll('[data-welcome-open]').forEach(el=>{el.setAttribute('aria-haspopup','dialog');el.setAttribute('aria-controls',this.dialog.id);el.setAttribute('aria-expanded','false')})};
      if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',enableOpeners,{once:true,signal:this.abortController.signal});else enableOpeners();
      document.addEventListener('click',e=>{const trigger=e.target.closest('[data-welcome-open]');if(!trigger)return;e.preventDefault();this.open(trigger)},options);
      const form=this.querySelector('form');
      form?.addEventListener('submit',e=>{if(this.editor){e.preventDefault();return}const n=this.querySelector('[data-welcome-name]');if(n){n.value=n.value.trim();if(!n.value){e.preventDefault();n.reportValidity();return}}try{sessionStorage.setItem(this.pendingKey,'1')}catch(err){}},options);
      this.querySelector('[data-welcome-shop]')?.addEventListener('click',()=>this.remember(365),options);
      this.querySelector('[data-welcome-copy]')?.addEventListener('click',async e=>{const status=this.querySelector('[data-welcome-status]');try{await navigator.clipboard.writeText(e.currentTarget.dataset.code);status.textContent=status.dataset.copied}catch(err){status.textContent=status.dataset.copyFallback}},options);
      if(this.editor){document.addEventListener('shopify:section:select',e=>{if(e.target.contains(this))this.open()},options);document.addEventListener('shopify:section:deselect',e=>{if(e.target.contains(this))this.dialog.close()},options);return}
      let pending=false;try{pending=sessionStorage.getItem(this.pendingKey)==='1'}catch(err){}
      if(this.querySelector('[data-welcome-errors]')||(pending&&this.querySelector('[data-welcome-success]'))){this.open();if(this.querySelector('[data-welcome-success]')){this.remember(365);try{sessionStorage.removeItem(this.pendingKey)}catch(err){}}return}
      if(this.querySelector('[data-welcome-success]'))return;
      if(this.dataset.autoOpen!=='true')return;
      let until=0;try{until=Number(localStorage.getItem(this.storageKey))||0}catch(err){}if(until>Date.now())return;
      this.timer=setTimeout(()=>this.open(),Number(this.dataset.delay)*1000);
    }
    open(trigger){clearTimeout(this.timer);if(!this.isConnected||this.dialog.open||document.querySelector('dialog[open]'))return;this.opener=trigger||document.activeElement;this.previousOverflow=document.documentElement.style.overflow;this.setAttribute('data-open','');this.dialog.showModal();document.querySelectorAll('[data-welcome-open]').forEach(b=>b.setAttribute('aria-expanded','true'));document.documentElement.style.overflow='hidden';this.scrollLocked=true}
    remember(days){if(this.editor)return;try{localStorage.setItem(this.storageKey,String(Date.now()+(days||Number(this.dataset.days))*86400000))}catch(err){}}
    unlockScroll(){if(!this.scrollLocked)return;document.documentElement.style.overflow=this.previousOverflow;this.scrollLocked=false}
    disconnectedCallback(){clearTimeout(this.timer);this.abortController?.abort();this.unlockScroll()}
  });

  } catch(e) { console.error(e); }
})();
})();
